import React from 'react';
import Section from '../section/Section';
import Warning from '../messages/Warning';

const AccessForbidden = () => {
  return (
    <Section>
      <Warning
        messageType="info"
        messageHeader="Aðgangur "
        messageBody="Þú hefur ekki aðgang að þessari vöru. Hafðu samband við Creditinfo á creditinfo@creditinfo.is ef þú vilt óska eftir aðgangi."
      />
    </Section>
  );
};

export default AccessForbidden;



// WEBPACK FOOTER //
// ./src/common/jsx/elements/banners/AccessForbidden.js